export default {
  refunds: {
    titleState: {
      title1: 'After-sales Request',
      title2: 'Refund Details'
    },
    sqsh: {
      shInfo1: 'Select',
      shInfo2: 'Order Information',
      shInfo3: 'Quantity',
      shInfo4: 'Action',
      shInfo5: 'Order No.:',
      shInfo6: 'Specs:',
      shInfo7: 'Request Refund',
      shInfo8: 'Refund Requested',
      shInfo9:'Application deadline：',
    },
    tkmx: {
      tkmx1: 'Service No.',
      tkmx2: 'Service Type',
      tkmx3: 'Product Name',
      tkmx4: 'Return Qty',
      tkmx5: 'Claim Amount',
      tkmx7: 'Total Claim',
      tkmx8: 'Actual Refund',
      tkmx9: 'Action',
      tkmx10: 'Select',
      tkmx11: 'All Statuses',
      tkmx12: 'View',
      tkmx13: 'Refund Breakdown',
      tkmx14:'contain',
      tkmx15:'freight',
    },
    tkmxDialog: {
      tkDialog1: 'Refund Method:',
      tkDialog2: 'Original Payment Method',
      tkDialog3: 'Refund Due:',
      tkDialog4: 'Actual Refund:',
      tkDialog5: 'Refund Status:',
      tkDialog6: 'Refund Details:',
      tkDialog7: 'Amount will be refunded to original payment account',
      tkDialog8: 'Processing delays may occur. Refer to your bank/payment account for actual credit time.',
      tkDialog9: 'Confirm'
    },
    spfhDialog: {
      spDialog1: 'For product returns: 1) Use COD shipping, or 2) Negotiate with merchant. Platform does not subsidize return shipping!',
      spDialog2: 'Courier Delivery',
      spDialog3: 'Self-Delivery',
      spDialog4: 'Courier:',
      spDialog5: 'Enter 2-10 character courier name',
      spDialog6: 'Tracking No.:',
      spDialog7: 'Enter 8-20 digit tracking number',
      spDialog8: 'Deliverer:',
      spDialog9: 'Enter deliverer name',
      spDialog10: 'Mobile:',
      spDialog11: 'Enter deliverer mobile number',
      spDialog12: 'Vehicle No.:',
      spDialog13: 'Enter vehicle plate number',
      spDialog14: 'Cancel',
      spDialog15: 'Submit'
    },
    rulesInfo: {
      rule1: 'Enter courier name',
      rule2: 'Enter tracking number',
      rule3: 'Enter deliverer name',
      rule4: 'Enter deliverer mobile'
    },
    orderList:{
      ord1:'Enter three-month orders',
      ord2:'Orders for 2025',
      ord3:'Orders for 2024',
      ord4:'Orders for 2023',
      ord5:'Orders for 2022'
    }
  }
}